import './elephantsdeli/style';
import FormStructure from './elephantsdeli/form_structure';

export default FormStructure;